import { render, staticRenderFns } from "./ViewRating.vue?vue&type=template&id=2b3bdd19&scoped=true"
import script from "./ViewRating.vue?vue&type=script&lang=js"
export * from "./ViewRating.vue?vue&type=script&lang=js"
import style0 from "./ViewRating.vue?vue&type=style&index=0&id=2b3bdd19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3bdd19",
  null
  
)

export default component.exports